<template>
  <div class="container">
    <Modal
      width="600"
      v-model="showModal"
      @on-cancel="clear"
      title="灰度投放"
    >
    <Form :rules="ruleValidate"  ref="grayform" :model="form" :label-width="120">
        <FormItem label="投放策略" prop="strategy">
          <CheckboxGroup @on-change="startegyChange" v-model="form.strategy">
            <Checkbox label="渠道">渠道</Checkbox>
            <Checkbox label="省份">省份</Checkbox>
            <Checkbox label="电视品牌">电视品牌</Checkbox>
            <Checkbox label="安卓版本">安卓版本</Checkbox>
            <Checkbox label="底座版本" :disabled="type !== 'rpk'">底座版本</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="渠道" v-if="form.strategy.includes('渠道')" prop="channelCodeList">
          <Select v-model="form.channelCodeList" placeholder="请选择渠道,可多选" multiple filterable>
            <Option :value="item.value" v-for="(item) in channelList" :key="item.value">{{item.text + ' | ' + item.value}}</Option>
          </Select>
        </FormItem>

        <FormItem label="省份" v-if="form.strategy.includes('省份')" prop="provinceList">
          <Select v-model="form.provinceList" placeholder="请选择省份,可多选" multiple filterable>
            <Option :value="item.label" v-for="(item) in utils.cityList" :key="item.label" >{{item.label}}</Option>
          </Select>
        </FormItem>
        <FormItem label="电视品牌" v-if="form.strategy.includes('电视品牌')" prop="brandList">
          <!-- allow-create -->
          <Select v-model="form.brandList" allow-create  placeholder="请选择电视品牌,可多选" multiple filterable>
            <Option v-for="(item) in tvBrandList" :key="item.value" :value="item.value">{{item.title}}</Option>
            <!-- tvBrandList -->
            <!-- Add more options as needed -->
          </Select>
        </FormItem>
        <FormItem label="安卓版本" v-if="form.strategy.includes('安卓版本')" prop="ge_android">
          <Row>
            <Col span="24" style="display:flex;">
              <div>大于等于</div>
              <Select v-model="form.ge_android" style="width:200px;margin-left:10px;" placeholder="大于等于" filterable>
                <Option v-for="(item) in versionList" :key="item.value" :value="item.value">{{item.title}}</Option>
              </Select>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="安卓版本" v-if="form.strategy.includes('安卓版本')" prop="le_android">
          <Row>
            <Col span="24" style="display:flex;">
            <div>小于等于</div>
              <Select v-model="form.le_android" style="width:200px;margin-left:10px;" placeholder="小于等于" filterable>
                <Option v-for="(item) in versionList" :key="item.value" :value="item.value">{{item.title}}</Option>
              </Select>
            </Col>
          </Row>
        </FormItem>

        <FormItem label="底座版本" v-if="form.strategy.includes('底座版本')" prop="sdkVersionList">
          <Select v-model="form.sdkVersionList" placeholder="请选择底座版本,可多选" multiple filterable>
            <Option v-for="(item) in runtimeSdkVersionList" :key="item.value" :value="item.value">{{item.title}}</Option>
          </Select>
        </FormItem>

        <FormItem label="投放比例" prop="range">
          <Input v-model="form.range" type="number" placeholder="请输入投放比例">
            <template slot="suffix"><div style="margin-top:8px;">%</div></template>
          </Input>
        </FormItem>
        <FormItem label="偏移量" prop="offset">
          <Input v-model="form.offset" type="number" placeholder="请输入偏移量"></Input>
        </FormItem>

        <FormItem label="投放设置" prop="status">
          <RadioGroup v-model="form.status">
            <Radio :label="0" :disabled="statusFlag">正常投放</Radio>
            <div></div>
            <Radio :label="-1" :disabled="statusFlag">停止投放，规则失效</Radio>
            <div></div>
            <Radio :label="1" :disabled="statusFlag">全量投放，该版本面向所有用户</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="editData">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import https from '../../https'
import utils from '../../utils'
export default {
  name: 'grayModal',
  data () {
    return {
      utils,
      showModal: false,
      channelList: [],
      versionList: [],
      runtimeSdkVersionList: [],
      brandList: [],
      loading: true,
      type: '',
      tvBrandList: [],
      rangeOrigin: '',
      statusFlag: false,
      form: {
        strategy: [],
        channelCodeList: [],
        provinceList: [],
        brandList: [],
        ge_android: '',
        le_android: '',
        sdkVersionList: [],
        range: '',
        offset: '',
        status: 0
      },
      url: {
        channelList: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=app_channel_code',
        androidVersion: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=android_version',
        runtimeSdkVersion: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=runtime_sdk_version',
        tvBrand: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=tv_brand',
        queryByDataId: 'extscreenapi/plugin/hili/grayConfig/queryByDataId',
        setGrayConfig: 'extscreenapi/plugin/hili/grayConfig/setGrayConfig'
      },
      ruleValidate: {
        strategy: [
          { required: false, message: '请选择投放策略' }
        ],
        channelCodeList: [
          { required: true, message: '请选择渠道' }
        ],
        provinceList: [
          { required: true, message: '请选择省份' }
        ],
        brandList: [
          { required: true, message: '请选择电视品牌' }
        ],
        ge_android: [
          { required: true, message: '请选择安卓版本' }
        ],
        le_android: [
          { required: true, message: '请选择安卓版本' }
        ],
        sdkVersionList: [
          { required: true, message: '请选择底座版本' }
        ],
        range: [
          { required: true, message: '请输入投放比例' },
          { pattern: /^([1-9][0-9]?|100)$/, message: '投放比例必须是1到100之间的正整数' }
        ],
        offset: [
          { required: false, message: '请输入偏移量' }
        ],
        status: [
          { required: true, message: '请选择投放设置' }
        ]
      }
    }
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.token = https.token
  },
  mounted () {
  },
  methods: {
    clear () {
      this.showModal = false
      this.form = {
        strategy: [],
        channelCodeList: [],
        provinceList: [],
        brandList: [],
        ge_android: '',
        le_android: '',
        sdkVersionList: [],
        range: '',
        offset: '',
        status: 0
      }
    },
    cancel () {
      this.clear()
    },
    editData () {
      this.loading = true
      this.$refs.grayform.validate((valid) => {
        this.loading = false
        if (valid) {
          if (this.form.range < this.rangeOrigin) {
            this.showModal = true
            this.$Message.error(`投放比例不能低于${this.rangeOrigin}`)
            return
          }
          if (!this.form.strategy.includes('渠道')) {
            this.form.channelCodeList = []
          }
          if (!this.form.strategy.includes('省份')) {
            this.form.provinceList = []
          }
          if (!this.form.strategy.includes('电视品牌')) {
            this.form.brandList = []
          }
          if (!this.form.strategy.includes('安卓版本')) {
            this.form.ge_android = ''
            this.form.le_android = ''
          }
          if (!this.form.strategy.includes('底座版本')) {
            this.form.sdkVersionList = []
          }
          let params = {
            dataId: this.id,
            brandList: this.form.brandList,
            channelCodeList: this.form.channelCodeList,
            ge_android: this.form.ge_android,
            le_android: this.form.le_android,
            provinceList: this.form.provinceList,
            range: this.form.range,
            offset: this.form.offset,
            sdkVersionList: this.form.sdkVersionList,
            typeCode: this.type,
            status: this.form.status
          }
          https.request({
            method: 'post',
            url: this.url.setGrayConfig,
            headers: {
              'Content-Type': 'application/json',
              'satoken': https.token
            },
            data: params
          }).then(res => {
            console.log('------------', res)
            if (res.code === 400 || res.code === 500) {
              this.$Message.success(res.data.message)
              this.changeLoading()
              return
            }
            if (res.code === 200) {
              this.cancel()
              this.$Message.success('保存成功')
              this.showModal = false
              this.$emit('close')
            }
            if (res.data.code === 400) {
              this.$Message.success(res.data.message)
              this.changeLoading()
              return
            }
            this.changeLoading()
          })
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    startegyChange (val, val1) {
      console.log(val, val1)
    },
    show (id, type) {
      this.id = id
      this.type = type
      this.queryByDataId(id)
      this.getChannelList()
      this.getVersionList()
      this.getTvBrandList()
      this.runtimeSdkVersion()
      this.showModal = true
      // let params = {}
      // let url = ''
    },
    queryByDataId (id) {
      https.request({
        method: 'get',
        url: this.url.queryByDataId,
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        },
        params: {
          dataId: id,
          typeCode: this.type
        }
      }).then(res => {
        console.log('======', res)
        if (res.result === null) {
          this.statusFlag = false
          this.rangeOrigin = 0
        } else {
          this.rangeOrigin = res.result.range
          if (res.result.status === 0) {
            this.statusFlag = false
          } else {
            this.statusFlag = true
          }
          let arr = []
          if (res.result.channelCodeList.length !== 0) {
            arr.push('渠道')
          }
          if (res.result.provinceList.length !== 0) {
            arr.push('省份')
          }
          if (res.result.brandList.length !== 0) {
            arr.push('电视品牌')
          }
          if (res.result.ge_android.length !== 0 && res.result.le_android.length !== 0) {
            arr.push('安卓版本')
          }
          if (res.result.sdkVersionList.length !== 0) {
            arr.push('底座版本')
          }
          this.form = {
            strategy: arr,
            channelCodeList: res.result.channelCodeList,
            provinceList: res.result.provinceList,
            brandList: res.result.brandList,
            ge_android: res.result.ge_android,
            le_android: res.result.le_android,
            sdkVersionList: res.result.sdkVersionList,
            range: res.result.range,
            offset: res.result.offset || '',
            status: res.result.status
          }
        }
      })
    },
    getChannelList (params) {
      https.request({
        method: 'get',
        url: this.url.channelList
      }).then(res => {
        res.result.map((item, index) => {
          if (item.value === 'ALLCHANNEL') {
            res.result.splice(index, 1)
          }
          if (item.value === 'CESHI') {
            res.result.splice(index, 1)
          }
          if (item.value === 'GENERAL') {
            res.result.splice(index, 1)
          }
        })
        this.channelList = res.result
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getVersionList (params) {
      https.request({
        method: 'get',
        url: this.url.androidVersion
      }).then(res => {
        this.versionList = res.result
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getTvBrandList (params) {
      https.request({
        method: 'get',
        url: this.url.tvBrand
      }).then(res => {
        this.tvBrandList = res.result
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    runtimeSdkVersion (params) {
      https.request({
        method: 'get',
        url: this.url.runtimeSdkVersion
      }).then(res => {
        this.runtimeSdkVersionList = res.result
        this.runtimeSdkVersionList.shift()
      }).catch(error => {
        this.$Message.error(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/grayModal.vue